/**
 * Enum representing the possible error types.
 * @readonly
 * @enum {string}
 */
export enum ErrorType {
  /**
   * Represents a not found error.
   */
  NotFound = 'not_found',

  /**
   * Represents a generic error.
   */
  Error = 'error',

  /**
   * Represents a server error.
   */
  ServerError = 'server_error',

  /**
   * Represents a mobile error.
   */
  MobileAvailability = 'mobile_availability',

  /**
   * Represents a message for users that don't have any front product enabled.
   */
  AccountCreatedSuccessfully = 'account_created_successfully',
}

/**
 * Type representing the keys of the ErrorType enum.
 */
export type ErrorTypeKeys = (typeof ErrorType)[keyof typeof ErrorType];

/**
 * The types for the ErrorPageCard props.
 */
export type ErrorPageCardProps = {
  errorType?: ErrorTypeKeys;
};
